import { useState } from "react";

import Image from "next/image";
import { useRouter } from "next/router";

import { ConsolePageForm } from "pages/[tenant]/console/components/molecules/ConsolePageForm";
import { useConsolePageContext } from "pages/[tenant]/console/hooks/useConsolePageContext";
import ArrowLeft from "pages/[tenant]/g/assets/icons/ArrowLeft";

import { CustomGroupSectionLabelContainer, FallbackBackground } from "./styles";

export const CustomGroupSectionLabel = () => {
  const [failedToLoadImage, setFailedToLoadImage] = useState(false);
  const { back, push } = useRouter();
  const { closeMobileSectionsDropdown, currentGroup } = useConsolePageContext();

  const handleClick = () => {
    closeMobileSectionsDropdown();
    push("/console/groups");
  };

  const shouldShowGroupImage =
    !failedToLoadImage && !!currentGroup?.logo_horizontal;

  return (
    <CustomGroupSectionLabelContainer>
      <ConsolePageForm.Button
        variant="transparent"
        onClick={handleClick}
        style={{ width: "100%", justifyContent: "start" }}
        id="group-config-return-page-button"
      >
        <ArrowLeft /> Grupos & Recursos
      </ConsolePageForm.Button>

      {!!currentGroup && (
        <div className="group" title={currentGroup?.title}>
          {shouldShowGroupImage ? (
            <Image
              alt=""
              src={currentGroup?.logo_horizontal}
              width={45}
              height={25}
              onError={() => setFailedToLoadImage(true)}
            />
          ) : (
            <FallbackBackground backgroundColor={currentGroup?.primary_color} />
          )}

          <span>{currentGroup?.title}</span>
        </div>
      )}
    </CustomGroupSectionLabelContainer>
  );
};
